<div class="powered-by-container">
  <strong>Powered by:</strong> <img src="/assets/logos/logo-get-covered.svg" alt="GetCovered logo">
</div>
